// eslint-disable-next-line import/prefer-default-export
export const AdminPageConstants = {
  pageHeader: 'NAE - Admin',
  tagline: 'Configuration Management',
  categoryLabel: 'Category',
  pageId: 'admin-home',
};
